var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftovers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 415.27,
    y1: 586.25,
    x2: 444.5,
    y2: 586.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#754c24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#754c24",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 444.09,
    y1: 581.94,
    x2: 482.1,
    y2: 581.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 482.1,
    y1: 585.46,
    x2: 518.81,
    y2: 585.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 533.06,
    y1: 598.07,
    x2: 569.77,
    y2: 598.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 510.59,
    y1: 589.41,
    x2: 548.73,
    y2: 589.41,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftovers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.9,
    y: -0.47,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "leftovers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sausage"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.32,208.86c-2.07,29-21,56.36-52.9,65.66l-3.5,1a74.2,74.2,0,0,1-70-16c-45.14-39.95-108.73-54.45-167.22-35.85-60.19,19.15-104.36,70-116.82,130.6a73.58,73.58,0,0,1-50.26,55.31c-1.94.61-3.88,1.22-5.82,1.81-33.35,10.41-66.1-3.85-83.31-29.45a75,75,0,0,1,1.12-8.53c23.17-122.81,114-225.47,235.65-257,107.32-27.81,221.36,4.2,301.9,79.36A74.72,74.72,0,0,1,671.32,208.86Z",
    style: {
      fill: "#ea7847"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.51,343.86l-11.36,6.05c-8.63,4.59-20.1.06-25.06-9.27a20,20,0,0,1-1.23-2.79l-.82-2.29-9.57-26.94a20.57,20.57,0,0,1-.86-3.12,16.58,16.58,0,0,1,.22-7.72,14.69,14.69,0,0,1,7.74-9.24,16.18,16.18,0,0,1,7.29-1.69c4.73,0,9.79,2,14.07,6.59l13.46,14.32,8.31,8.86C718,325.48,717,338.82,707.51,343.86Z",
    style: {
      fill: "#ea7847"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.46,517.54l-12.26,3.93c-9.3,3-19.79-3.52-23-13.58a20,20,0,0,1-.72-3l-.39-2.39-4.36-26.62-.26-1.59a17.72,17.72,0,0,1,1.31-10.77,14.18,14.18,0,0,1,4.59-5.46,12.28,12.28,0,0,1,2.4-1.41c6-2.81,13.86-1.78,19.73,4.36a23.63,23.63,0,0,1,2.69,3.42l17.28,26.67C223.08,501.33,219.64,514.26,209.46,517.54Z",
    style: {
      fill: "#ea7847"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.86,466.11a17.79,17.79,0,0,1-6.58,8.63l-1.56,1.16-21.41,15.86-2,1.43a17.69,17.69,0,0,1-2.58,1.63c-9.33,5-21.37,2.34-26-6.3l-6-11.36c-5-9.44,1.54-21.1,13.39-23.82L151.9,447l3.23-.74c10.77-2.45,19.06,3.06,21.63,10.42a14,14,0,0,1,.6,2.22A14.5,14.5,0,0,1,176.86,466.11Z",
    style: {
      fill: "#ea7847"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.32,281.38l-1.09,12.83c-.82,9.74-10.85,16.92-21.38,16a23.09,23.09,0,0,1-3-.48l-2.36-.56-6.08-1.44-21.74-5.14a17.88,17.88,0,0,1-9.45-5.35,15.14,15.14,0,0,1-1.7-2.34,14.79,14.79,0,0,1-1.93-6.39c-.5-7.36,4.37-15.23,14.12-17.71.55-.14,1.09-.26,1.66-.37l31.27-5.69C725.58,262.59,736.2,270.72,735.32,281.38Z",
    style: {
      fill: "#ea7847"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.32,208.86c-2.07,29-21,56.36-52.9,65.66l-3.5,1a74.2,74.2,0,0,1-70-16c-45.14-39.95-108.73-54.45-167.22-35.85-60.19,19.15-104.36,70-116.82,130.6a73.58,73.58,0,0,1-50.26,55.31c-1.94.61-3.88,1.22-5.82,1.81-33.35,10.41-66.1-3.85-83.31-29.45a74.13,74.13,0,0,0,52.84,76.07q1.48.45,3,.81A71.06,71.06,0,0,0,196.49,461a74.32,74.32,0,0,0,20.56-3.4l5.82-1.82a73.55,73.55,0,0,0,50.26-55.3c12.46-60.65,56.64-111.46,116.82-130.6,58.49-18.61,122.08-4.1,167.22,35.84a74.2,74.2,0,0,0,70,16l3.5-1a73.64,73.64,0,0,0,28-15.19,72.7,72.7,0,0,0,15.25-18.65,74.27,74.27,0,0,0-2.54-78Z",
    style: {
      fill: "#ea5f24"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "plate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.32,740.79c5.33-.36,12.47-.49,17.61.88a38.87,38.87,0,0,1,10.14,4.2l.1.06a2.21,2.21,0,0,1,.23.17,34,34,0,0,1,4.89,4c.14.13.28.26.41.4l.09.09.33.35c.41.42.82.88,1.21,1.35a53.05,53.05,0,0,1,4.14-3.32c.95-.7,2-1.39,3.06-2q-1.15-1.44-2.46-2.79l-.27-.27-.11-.09,0,0c-.61-.25-1.24-.5-1.86-.73A63.63,63.63,0,0,0,290.28,739h-1.44a64.42,64.42,0,0,0-10,1C277.65,740.27,276.48,740.5,275.32,740.79Z",
    style: {
      fill: "#ffff9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,808.14a53.22,53.22,0,0,1-34.24,49.75h0a53.31,53.31,0,0,1-67.77-28.36,51.84,51.84,0,0,1-2.41-6.66c-.45-1.53-.81-3.09-1.11-4.66A53.24,53.24,0,0,1,372,761.3c.51-.28,1-.55,1.55-.81a55.59,55.59,0,0,1,5.93-2.53,53.33,53.33,0,0,1,67.21,30.1l.33.84h0s0,0,0,0a6.32,6.32,0,0,1,.22.61q.88,2.36,1.54,4.81A53.14,53.14,0,0,1,450.59,808.14Z",
    style: {
      fill: "#ffd952"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27,803a64,64,0,0,0,122.3,26.49,65.47,65.47,0,0,0,2.58-6.66,57.8,57.8,0,0,0,1.63-6,63.9,63.9,0,0,0-6.15-44.24,65.19,65.19,0,0,0-5-7.8,64.33,64.33,0,0,0-21.37-18.37c-1.65-.89-3.36-1.69-5.1-2.43h0L315,744a1.21,1.21,0,0,1-.2-.09l-.15,0c-.61-.25-1.24-.5-1.86-.73A63.63,63.63,0,0,0,290.28,739h-1.44a64.42,64.42,0,0,0-10,1c-1.19.22-2.36.45-3.52.74-.89.2-1.76.43-2.62.68a64.18,64.18,0,0,0-45.06,48.34h0A64.65,64.65,0,0,0,226.27,803Z",
    style: {
      fill: "#ffd952"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38,830.8a42,42,0,0,1-18.45,34.75l-56.52-9a41.81,41.81,0,0,1-8.86-25.77,39.8,39.8,0,0,1,.38-5.6c.1-.79.22-1.56.37-2.33a41.26,41.26,0,0,1,6.76-16,41.93,41.93,0,0,1,73.11,7.83,41.15,41.15,0,0,1,2.47,8.18c.15.78.27,1.55.37,2.34A41.37,41.37,0,0,1,278.38,830.8Z",
    style: {
      fill: "#ffd952"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.91,776.42a41.92,41.92,0,0,0,41.75,41.91h.17q1.62,0,3.21-.12a41.93,41.93,0,0,0,37.22-52.85c-.24-.92-.52-1.82-.83-2.71-.08-.21-.14-.42-.23-.63v0l-.19-.49c-.09-.23-.17-.45-.27-.68s-.15-.38-.22-.56q-.21-.51-.45-1c-.18-.43-.38-.87-.6-1.29-.12-.25-.25-.5-.38-.75a41.91,41.91,0,0,0-37.26-22.71h-.17a41.72,41.72,0,0,0-26.47,9.56h0a.81.81,0,0,1-.1.09h0a42.68,42.68,0,0,0-3.85,3.63v0L311,748h0q-1.16,1.25-2.19,2.58A41.67,41.67,0,0,0,299.91,776.42Z",
    style: {
      fill: "#ffd952"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.24,830.8a40.71,40.71,0,0,1-.23,4.3,41.91,41.91,0,0,1-73.66,22.79h0a41.69,41.69,0,0,1-9.94-27.09A41.74,41.74,0,0,1,445.7,789h0l.3,0c.33,0,.67,0,1-.05h1.31a41.91,41.91,0,0,1,41.92,41.92Z",
    style: {
      fill: "#ffd952"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.32,790c-.11.1-.57-.17-1.08-.46a8.58,8.58,0,0,0-1-.52h0A.85.85,0,0,0,446,789a.31.31,0,0,0-.3,0h0l-.14.14h0c-1.53,1.37-3.95,3-6.41,1.72,0,0-.07,0-.07,0-.08.23.5,1.69.21,1.42a7.82,7.82,0,0,1-.84-1.18c-.19-.29-.4-.6-.58-.91-.37-.59-.7-1.11-.85-1.31-5.76-7.86-20.44-26.82-43-26.06h-.12a52.6,52.6,0,0,0-11.62,2.53,59.72,59.72,0,0,0-21.69,13.21,1.13,1.13,0,0,1-1.74-1.39,57.78,57.78,0,0,1,6.79-9.83,54.23,54.23,0,0,1,6.52-5.83c.45-.35.92-.69,1.4-1a42.32,42.32,0,0,1,5.55-3.28c.14.25.26.5.38.75a53.33,53.33,0,0,1,67.21,30.1l.33.84h.4l.35,0,0,0C448,789.25,448.15,789.63,448.32,790Z",
    style: {
      fill: "#ffff9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.52,833.38c-.11.1-.5-.25-.92-.65a7,7,0,0,0-.83-.69,1.13,1.13,0,0,0-.22-.11.21.21,0,0,0-.26,0h0l-.16.14h0a9.31,9.31,0,0,1-2.82,1.89,3.05,3.05,0,0,1-3.2-.51s-.06,0-.06,0c-.1.25.24,2,0,1.66a8.26,8.26,0,0,1-.63-1.44c-.13-.37-.28-.74-.4-1.1a6.33,6.33,0,0,1-2.3-.67c-3.1-1.64-3.4-5.54-4.24-10.2a37.27,37.27,0,0,0-1.43-5.66A28.72,28.72,0,0,0,471,803.61c-7.67-6.14-16.83-6.72-19.1-6.79h-.4a39.22,39.22,0,0,0-10.83,1.82c-5.58,1.73-12.26,6.26-16.62,9.53a1.13,1.13,0,0,1-1.62-1.53c3-4.65,8.23-11.32,15.17-15.26a33,33,0,0,1,3-1.51,29.94,29.94,0,0,1,3.81-1.28,28.32,28.32,0,0,1,3.43-.64,4.09,4.09,0,0,1,.6-.07c.28,0,.56-.06.82-.07s.52,0,.77,0h.54a41.93,41.93,0,0,1,41.17,34,5.18,5.18,0,0,1,1,.08l.81.1a1.12,1.12,0,0,1,.88.82c.8,3,1.36,5.75,1.85,8.2l.21,1,.36,0h.34A1.6,1.6,0,0,1,497.52,833.38Z",
    style: {
      fill: "#ffff9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,753.75l.33-.3c1.22-1.07,2.6-2.21,4.14-3.32.95-.7,2-1.39,3.06-2q1.32-.83,2.76-1.59a45.5,45.5,0,0,1,4.87-2.25,44.92,44.92,0,0,1,12-2.93h.11a31.9,31.9,0,0,1,4.4.16C356.59,743,366.89,754.61,372,761.3a1.53,1.53,0,0,1,.16.22c.48.61.9,1.18,1.27,1.69,2.79,3.8,5.87,1.44,7.48-.05a1.09,1.09,0,0,0,.31-1.14v0s0,0,0,0l-.17-.44c-.09-.23-.17-.45-.27-.68s-.15-.38-.22-.56l-.12-.29c-.1-.24-.21-.49-.33-.73-.18-.43-.38-.87-.6-1.29-.12-.25-.25-.5-.38-.75a41.91,41.91,0,0,0-37.26-22.71h-.17a41.72,41.72,0,0,0-26.47,9.56h0L315,744c-.09-.17-.19-.24-.29-.19h0l0,0-.52.52c-.29.28-.53.53-.74.74a26.24,26.24,0,0,0-2.17,2.69v0l-.19.26-.52.75c-.44.65-.9,1.37-1.38,2.15l-.42.69-.41.67A1.13,1.13,0,0,0,310,753.75Z",
    style: {
      fill: "#ffff9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.22,842.35,668.06,877H331.94l-72-11.42-56.52-9-89.63-14.22c-10.49-1.67-9.27-17.15,1.35-17.15H884.87C895.49,825.2,896.71,840.68,886.22,842.35Z",
    style: {
      fill: "#d5eaf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.87,877v11.1a8.63,8.63,0,0,1-8.63,8.63H343.45a8.62,8.62,0,0,1-8.62-8.63V877Z",
    style: {
      fill: "#c0e2fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.59,896.7H343.45a8.62,8.62,0,0,1-8.62-8.63V877h-2.89l-72-11.42-56.52-9-89.63-14.22c-10.49-1.67-9.27-17.15,1.35-17.15H307.9c14.4,6,23.55,12,32.61,17.52,12.15,7.41,24.17,13.94,48.55,18.23a257.21,257.21,0,0,0,34.23,3.46c14.65.66,28.94.71,45.81,2.78A270.6,270.6,0,0,1,514.79,877c18.21,5.46,13.36,5.69,28.35,9.86C568.09,893.79,588.15,895,609.59,896.7Z",
    style: {
      fill: "#9ed0ef",
      fillOpacity: 0.46
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bread"
  }, /*#__PURE__*/React.createElement("g", {
    id: "backup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875.41,567.33v74.11c0,8.7-7.74,15.74-17.28,15.74H565.47a13,13,0,0,0-3.16-8,16,16,0,0,0-10.18-5c-1.1-.09-2.23-.14-3.36-.15,1.4-2.9-1.33-6-7.79-8A51.64,51.64,0,0,0,519,635c-2-2.86-8-5.2-16.05-5.89s-16,.45-21,2.7c-5-2.24-13.05-3.36-21.1-2.65a42.59,42.59,0,0,0-7.47,1.28l-.57-74.06H870.85a16.16,16.16,0,0,1,4.07,7.19.07.07,0,0,1,0,.06A15,15,0,0,1,875.41,567.33Z",
    style: {
      fill: "#d8b593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.85,556.33H452.71L338.88,515.64l-34.75-12.42h0a24,24,0,0,1,12.67-3.54H713a26.16,26.16,0,0,1,8.88,1.54l138.48,49.7,6.69,2.41A17.38,17.38,0,0,1,870.85,556.33Z",
    style: {
      fill: "#f7cb92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.28,556.33l-.57,74.21c-3.89,1.11-6.69,2.71-7.91,4.5a51.41,51.41,0,0,0-22,1.12c-3.92,1.21-6.37,5.49-7.35,7.31l-.11.2L312,606.86c-10.71-3.82-17.76-13.23-17.76-23.7V520.29a20.18,20.18,0,0,1,9.93-17.07h0l34.72,12.36L387.71,533,415,542.68l2.05.73,2.47.88h0l2.82,1h0Z",
    style: {
      fill: "#c69c6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.2,547.47c-4.35-.3-10.56-.7-18-1.13,0,0-50,6.57-96.16-3-46.76-9.65-45.69,6.25-137.27,5.78a812.65,812.65,0,0,1-104.06-7.35,53.23,53.23,0,0,1-13.07-1.64c-1.42-.37-2.82-.79-4.2-1.27l-63.87-22.26c-5.82-2-4.22-9.89,2-9.89,95.2-6.47,157.3-4.49,197.48-1.13a1004.47,1004.47,0,0,0,101.81,4c27-.32,49.26-1.69,64-2.83a6.19,6.19,0,0,1,1.12.11,5.47,5.47,0,0,1,1.07.3L779.72,526q41.47,12.79,40.35,18.09Q819.05,548.92,782.2,547.47Z",
    style: {
      fill: "#ffe6a9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "meetvursti"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.59,522.06c-.62-11.79-48.4-21.3-107.27-21.3s-106.64,9.51-107.26,21.3h0v7.1a4,4,0,0,0,.12,1c.67,3.14,4.73,6.1,11.43,8.75,17.69,7,53.95,11.82,95.79,11.82s78.12-4.81,95.82-11.82c7.38-2.77,11.54-5.89,11.54-9.2v-7.62Z",
    style: {
      fill: "#772a15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.32,
    cy: 522.07,
    rx: 100.49,
    ry: 20.15,
    style: {
      fill: "#99251c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.14,
    cy: 516.69,
    rx: 6.99,
    ry: 2.07,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.43,
    cy: 529.87,
    rx: 6.99,
    ry: 2.07,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 520.7,
    cy: 511.51,
    rx: 3.49,
    ry: 1.04,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 536.09,
    cy: 519.59,
    rx: 4.18,
    ry: 1.24,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.29,
    cy: 531.94,
    rx: 4.18,
    ry: 1.24,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.93,
    cy: 514.61,
    rx: 3.49,
    ry: 1.04,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.5,
    cy: 527.8,
    rx: 3.49,
    ry: 1.04,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.82,
    cy: 518.76,
    rx: 3.49,
    ry: 1.04,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 458.86,
    cy: 525.73,
    rx: 6.99,
    ry: 2.07,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 476.74,
    cy: 517.17,
    rx: 5.36,
    ry: 1.59,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.2,
    cy: 506.62,
    rx: 5.36,
    ry: 1.59,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.62,
    cy: 527.8,
    rx: 5.36,
    ry: 1.59,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.37,505.8c-2.25,0-4.06.54-4.06,1.21s1.81,1.2,4.06,1.2,4.06-.54,4.06-1.2S467.61,505.8,465.37,505.8Z",
    style: {
      fill: "#c98665"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "meetvursti-2",
    "data-name": "meetvursti"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.7,528.29c-.55-10.46-43-18.91-95.19-18.91s-94.64,8.45-95.19,18.91h0v6.3a4.3,4.3,0,0,0,.1.87c.6,2.78,4.2,5.41,10.15,7.76,15.7,6.22,47.87,10.49,85,10.49s69.33-4.27,85-10.49c6.55-2.46,10.24-5.23,10.24-8.16v-6.77Z",
    style: {
      fill: "#772a15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.51,
    cy: 528.3,
    rx: 89.18,
    ry: 17.88,
    style: {
      fill: "#99251c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.87,
    cy: 523.52,
    rx: 6.2,
    ry: 1.84,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 732.45,
    cy: 535.22,
    rx: 6.2,
    ry: 1.84,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 731.8,
    cy: 518.92,
    rx: 3.1,
    ry: 0.92,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 745.46,
    cy: 526.1,
    rx: 3.71,
    ry: 1.1,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.26,
    cy: 537.06,
    rx: 3.71,
    ry: 1.1,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 772.83,
    cy: 521.68,
    rx: 3.1,
    ry: 0.92,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.3,
    cy: 533.38,
    rx: 3.1,
    ry: 0.92,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.61,
    cy: 525.36,
    rx: 3.1,
    ry: 0.92,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.93,
    cy: 531.54,
    rx: 6.2,
    ry: 1.84,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 692.79,
    cy: 523.95,
    rx: 4.76,
    ry: 1.41,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 717.16,
    cy: 514.59,
    rx: 4.76,
    ry: 1.41,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.79,
    cy: 533.38,
    rx: 4.76,
    ry: 1.41,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.7,513.86c-2,0-3.61.48-3.61,1.07s1.62,1.07,3.61,1.07,3.6-.48,3.6-1.07S684.69,513.86,682.7,513.86Z",
    style: {
      fill: "#c98665"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M875.41,567.33v74.11c0,8.7-7.74,15.74-17.28,15.74H565.47l.12-.06c4.47-2.38,5.39-5.7,1.82-8.51a12.26,12.26,0,0,0-1.81-1.17l-.11-.06c-3.28-1.73-8.1-2.86-13.36-3.25-1.1-.09-2.23-.14-3.36-.15,1.4-2.9-1.33-6-7.79-8A51.64,51.64,0,0,0,519,635c-2-2.86-8-5.2-16.05-5.89s-16,.45-21,2.7c-5-2.24-13.05-3.36-21.1-2.65a42.59,42.59,0,0,0-7.47,1.28l-.57-74.06H565.59l0,23.81.1,0a12.21,12.21,0,0,0,2.09-1.28c3.59-2.77,2.5-5.92-2.08-8.22h0c6.8-1.35,11.45-4,11.45-7.09v-.14c0-3.06-4.65-5.66-11.42-7l-.12,0H870.85a16.16,16.16,0,0,1,4.07,7.19.07.07,0,0,1,0,.06A15,15,0,0,1,875.41,567.33Z",
    style: {
      fill: "#d8b593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.85,556.33H452.71L338.88,515.64l-34.75-12.42h0a24,24,0,0,1,12.67-3.54H713a26.16,26.16,0,0,1,8.88,1.54l138.48,49.7,6.69,2.41A17.38,17.38,0,0,1,870.85,556.33Z",
    style: {
      fill: "#f7cb92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.34,545.31h0l-2.82-1h0l-2.47-.88-2.05-.73L387.71,533l-48.84-17.4-34.72-12.36h0a20.18,20.18,0,0,0-9.93,17.07v62.87c0,10.47,7.05,19.88,17.76,23.7l103.36,36.81V640.6l.11-.18c1-1.6,3.43-3,7.35-4.26a51.41,51.41,0,0,1,22-1.12c1.22-1.79,4-3.39,7.91-4.5l.57-74.21ZM399,570.64c-6.83-1.34-11.49-4-11.51-7.07s4.62-5.75,11.43-7.1c-4.59-2.3-5.7-5.46-2.13-8.24s10.87-4.18,18.56-4.28v39.44c-7.62-.13-14.84-1.77-18.38-4.51S394.39,573,399,570.64Z",
    style: {
      fill: "#c69c6d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "meetvursti-3",
    "data-name": "meetvursti"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.73,522.06v7.63c0,3.3-4.16,6.42-11.54,9.19a118.29,118.29,0,0,1-19.42,5.41c-2.21.45-4.53.88-6.93,1.29h0l-.14,0h0l-.07,0c-4.59.78-9.52,1.48-14.74,2.1l-.18,0c-4.65.55-9.54,1-14.61,1.43h0q-6.88.55-14.22.91c-2.71.13-5.45.25-8.22.33-5.6.19-11.36.28-17.22.28-3.8,0-7.57,0-11.27-.11-13.42-.29-26.12-1.06-37.6-2.26a2.85,2.85,0,0,1-.41,0A277,277,0,0,1,415.43,544l-.11,0-.38-.09a111.75,111.75,0,0,1-17.36-5c-6.18-2.44-10.1-5.14-11.21-8a6.75,6.75,0,0,1-.22-.73,4.09,4.09,0,0,1-.11-1v-7.1h0c.46-8.73,26.78-16.21,64.31-19.51,13.15-1.15,27.68-1.79,43-1.79,31.2,0,59.28,2.67,78.87,6.93,17.38,3.79,28.09,8.84,28.38,14.37Z",
    style: {
      fill: "#772a15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.32,
    cy: 522.07,
    rx: 100.49,
    ry: 20.15,
    style: {
      fill: "#99251c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.14,
    cy: 516.69,
    rx: 6.99,
    ry: 2.07,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.43,
    cy: 529.87,
    rx: 6.99,
    ry: 2.07,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 520.7,
    cy: 511.51,
    rx: 3.49,
    ry: 1.04,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 536.09,
    cy: 519.59,
    rx: 4.18,
    ry: 1.24,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.29,
    cy: 531.94,
    rx: 4.18,
    ry: 1.24,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.93,
    cy: 514.61,
    rx: 3.49,
    ry: 1.04,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.5,
    cy: 527.8,
    rx: 3.49,
    ry: 1.04,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.82,
    cy: 518.76,
    rx: 3.49,
    ry: 1.04,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 458.86,
    cy: 525.73,
    rx: 6.99,
    ry: 2.07,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 476.74,
    cy: 517.17,
    rx: 5.36,
    ry: 1.59,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.2,
    cy: 506.62,
    rx: 5.36,
    ry: 1.59,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.62,
    cy: 527.8,
    rx: 5.36,
    ry: 1.59,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.37,505.8c-2.25,0-4.06.54-4.06,1.21s1.81,1.2,4.06,1.2,4.06-.54,4.06-1.2S467.61,505.8,465.37,505.8Z",
    style: {
      fill: "#c98665"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "meetvursti-4",
    "data-name": "meetvursti"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.7,528.29c-.55-10.46-43-18.91-95.19-18.91s-94.64,8.45-95.19,18.91h0v6.3a4.3,4.3,0,0,0,.1.87c.6,2.78,4.2,5.41,10.15,7.76,15.7,6.22,47.87,10.49,85,10.49s69.33-4.27,85-10.49c6.55-2.46,10.24-5.23,10.24-8.16v-6.77Z",
    style: {
      fill: "#772a15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.51,
    cy: 528.3,
    rx: 89.18,
    ry: 17.88,
    style: {
      fill: "#99251c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.87,
    cy: 523.52,
    rx: 6.2,
    ry: 1.84,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 732.45,
    cy: 535.22,
    rx: 6.2,
    ry: 1.84,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 731.8,
    cy: 518.92,
    rx: 3.1,
    ry: 0.92,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 745.46,
    cy: 526.1,
    rx: 3.71,
    ry: 1.1,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.26,
    cy: 537.06,
    rx: 3.71,
    ry: 1.1,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 772.83,
    cy: 521.68,
    rx: 3.1,
    ry: 0.92,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.3,
    cy: 533.38,
    rx: 3.1,
    ry: 0.92,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.61,
    cy: 525.36,
    rx: 3.1,
    ry: 0.92,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.93,
    cy: 531.54,
    rx: 6.2,
    ry: 1.84,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 692.79,
    cy: 523.95,
    rx: 4.76,
    ry: 1.41,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 717.16,
    cy: 514.59,
    rx: 4.76,
    ry: 1.41,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.79,
    cy: 533.38,
    rx: 4.76,
    ry: 1.41,
    style: {
      fill: "#c98665"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.7,513.86c-2,0-3.61.48-3.61,1.07s1.62,1.07,3.61,1.07,3.6-.48,3.6-1.07S684.69,513.86,682.7,513.86Z",
    style: {
      fill: "#c98665"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.71,637.91l.11,0Z",
    style: {
      fill: "#c94747"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.67,539v6c-.48.1-.94.22-1.39.33a37,37,0,0,0-5.19-1.87,46,46,0,0,0-8-1.67,50.06,50.06,0,0,0-13.81.28l-.44-.27-.39-.24a38.38,38.38,0,0,0-7.83-3.69,32.91,32.91,0,0,0-7.39-1.52,49.87,49.87,0,0,0-19.09,1.87c-.58.19-1.12.39-1.64.61l-.32.13,0,0c-5-2.16-13-3.24-21.05-2.55-5.83.51-10.56,1.84-13.47,3.6a8.3,8.3,0,0,0-2.48,2.16l-.6-.23-.41-.15c-7.06-2.56-12.34-2.44-15.91-1.81,0,0-1.07.19-5.74,1.66h0c-1.44.46-3.19,1-5.4,1.77l-.22.07-1.36.46v47.3a3,3,0,0,0-.11.43v-5.83a3.14,3.14,0,0,1,0-1.94v-40c-.18-.37.08-9.06.08-9.06a20.15,20.15,0,0,1,3.31-1.49c10.24-3.48,24.31,1.2,25.38,1.32l.41,0,.49.08c2-2.78,7.92-5.07,16-5.76s16.06.4,21.1,2.57l.05,0,.27-.12c.52-.22,1.06-.42,1.63-.61A49.93,49.93,0,0,1,503.1,529a45.83,45.83,0,0,1,7.49,1.21c3.89,1,6.78,2.45,8.22,4.1.13.13.23.27.34.4a53.29,53.29,0,0,1,22,1,24.58,24.58,0,0,1,3.38,1.26A12.25,12.25,0,0,1,547.67,539Z",
    style: {
      fill: "#c94747"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.59,545.51v8.19H547.67V539h.1v.13l.05,5.89a33,33,0,0,1,6.33-.61,31.12,31.12,0,0,1,6.77.71H561C561.53,545.22,562.08,545.35,562.59,545.51Z",
    style: {
      fill: "#772a15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.77,551.53v0a2.6,2.6,0,0,1-.06.56.22.22,0,0,1,0,.08,1.87,1.87,0,0,1-.08.32c-.42,1.47-1.83,2.78-3.87,3.82l0,0h0v14.22h0v16.9l-.07,60v9.74h-.12a13,13,0,0,0-3.16-8,16,16,0,0,0-10.18-5c-1.1-.09-2.23-.14-3.36-.15a3.21,3.21,0,0,0,0-3v0c-.92-1.87-3.53-3.63-7.75-4.91a41.05,41.05,0,0,0-7.92-1.51A53.89,53.89,0,0,0,519,635l-.14-.19c-1.36-1.78-4.26-3.33-8.22-4.39a42.65,42.65,0,0,0-7.69-1.31c-7.9-.68-15.78.41-20.8,2.59l-.25.11c-5-2.24-13.05-3.36-21.1-2.65a42.59,42.59,0,0,0-7.47,1.28l-.57.15c-3.89,1.11-6.69,2.71-7.91,4.5l-.3,0a2.9,2.9,0,0,0-.41-.06,50.92,50.92,0,0,0-21.31,1.22c-3.92,1.21-6.37,5.49-7.35,7.31V593.18a4,4,0,0,1-.11-.44,2.75,2.75,0,0,1,0-1.07,3,3,0,0,1,.11-.43v-47.3l1.36-.46.22-.07c2.21-.73,4-1.31,5.4-1.77h0c4.67-1.47,5.74-1.66,5.74-1.66,3.57-.63,8.85-.75,15.91,1.81l.41.15.6.23a8.3,8.3,0,0,1,2.48-2.16c2.91-1.76,7.64-3.09,13.47-3.6,8-.69,16,.39,21.05,2.55l0,0,.32-.13c.52-.22,1.06-.42,1.64-.61a49.87,49.87,0,0,1,19.09-1.87,32.91,32.91,0,0,1,7.39,1.52,38.38,38.38,0,0,1,7.83,3.69l.39.24.44.27a50.06,50.06,0,0,1,13.81-.28,46,46,0,0,1,8,1.67,37,37,0,0,1,5.19,1.87c.45-.11.91-.23,1.39-.33l.15,0a33,33,0,0,1,6.33-.61,31.12,31.12,0,0,1,6.77.71H561c.56.13,1.11.26,1.62.42l.23.07h0a13.74,13.74,0,0,1,5.26,2.74,4.81,4.81,0,0,1,1.57,2.4,2.41,2.41,0,0,1,.07.37A3.25,3.25,0,0,1,569.77,551.53Z",
    style: {
      fill: "#bc9471"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "bite-marks",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.5,528.84V635a2.9,2.9,0,0,0-.41-.06,50.92,50.92,0,0,0-21.31,1.22c-3.92,1.21-6.37,5.49-7.35,7.31l-.11.2V592.74a2.75,2.75,0,0,1,0-1.07,3,3,0,0,1,.11-.43v-47.3l1.36-.46.22-.07c2.21-.73,4-1.31,5.4-1.77h0c4.67-1.47,5.74-1.66,5.74-1.66,3.57-.63,8.85-.75,15.91,1.81V528.84Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.1,539v92.69l-.25.11c-5-2.24-13.05-3.36-21.1-2.65a42.59,42.59,0,0,0-7.47,1.28l-.57.15c-3.89,1.11-6.69,2.71-7.91,4.5l-.3,0a2.9,2.9,0,0,0-.41-.06V528.84h.41v13.1l.6.23a8.3,8.3,0,0,1,2.48-2.16c2.91-1.76,7.64-3.09,13.47-3.6C469.07,535.72,477.07,536.8,482.1,539Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.81,541.82v92.94c-1.36-1.78-4.26-3.33-8.22-4.39a42.65,42.65,0,0,0-7.69-1.31c-7.9-.68-15.78.41-20.8,2.59V539l0,0,.32-.13c.52-.22,1.06-.42,1.64-.61a49.87,49.87,0,0,1,19.09-1.87,32.91,32.91,0,0,1,7.39,1.52,38.38,38.38,0,0,1,7.83,3.69Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.77,551.53v0a2.6,2.6,0,0,1-.06.56.22.22,0,0,1,0,.08,1.87,1.87,0,0,1-.08.32c-.42,1.47-1.83,2.78-3.87,3.82l0,0h0v14.22h0v16.9l-.07,60v9.74h-.12a13,13,0,0,0-3.16-8,16,16,0,0,0-10.18-5c-1.1-.09-2.23-.14-3.36-.15l0-3v0c-.92-1.87-3.53-3.63-7.75-4.91a41.05,41.05,0,0,0-7.92-1.51V541.81a46,46,0,0,1,8,1.67,37,37,0,0,1,5.19,1.87c.45-.11.91-.23,1.39-.33V539h.1v.13l.05,5.89a33,33,0,0,1,6.33-.61,31.12,31.12,0,0,1,6.77.71H561c.56.13,1.11.26,1.62.42l.23.07h0a13.74,13.74,0,0,1,5.26,2.74,4.81,4.81,0,0,1,1.57,2.4,2.41,2.41,0,0,1,.07.37A3.25,3.25,0,0,1,569.77,551.53Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.73,640.94c-.92-1.87-3.53-3.63-7.75-4.91a41.05,41.05,0,0,0-7.92-1.51A53.89,53.89,0,0,0,519,635l-.14-.19c-1.36-1.78-4.26-3.33-8.22-4.39V537.89a38.38,38.38,0,0,1,7.83,3.69l.39.24.44.27a50.06,50.06,0,0,1,13.81-.28,46,46,0,0,1,8,1.67,37,37,0,0,1,5.19,1.87c.45-.11.91-.23,1.39-.33V539h.1v.13l.05,5.89,0,2.74v1.34l0,4.64Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftovers);
export default __webpack_public_path__ + "static/media/leftovers.c74e9fb3d37f2e016c046d266197a8ec.svg";
export { ForwardRef as ReactComponent };